import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { ApiModulesResponse, ModuleWithPermissions } from '../interfaces/modules.interface';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ModulesService {
  private readonly API_URL = environment.apiUrl || 'http://localhost:3333/api';
  private cachedModules: ModuleWithPermissions[] | null = null;

  constructor(private http: HttpClient) {}

  /**
   * Get modules available for current user with permissions
   */
  getMyModules(): Observable<ApiModulesResponse> {
    return this.http.get<ApiModulesResponse>(`${this.API_URL}/role-modules/my-modules`).pipe(
      tap(response => {
        if (response.success && response.data) {
          this.cachedModules = response.data;
        }
      })
    );
  }

  /**
   * Get cached modules
   */
  getCachedModules(): ModuleWithPermissions[] {
    return this.cachedModules || [];
  }

  /**
   * Clear cached modules
   */
  clearCache(): void {
    this.cachedModules = null;
  }

  /**
   * Whether the current user's role has a given permission (create/read/update/delete)
   * on a module, identified by slug. Used to gate actions (and the requests that back
   * them) the backend would reject anyway - e.g. skip loading car-transfer validation
   * for a role that only has read access to Cars.
   */
  hasPermission(slug: string, action: 'canCreate' | 'canRead' | 'canUpdate' | 'canDelete'): boolean {
    const module = this.getCachedModules().find(m => m.slug === slug);
    return !!module?.permissions?.[action];
  }
}
